import { AdminMessage } from "@components/admin/admin-helpers"
import { createBlock, defineBlock, EditableText } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Film Guests",
  tags: ["film-text"],
  icon: "businessman",
  description: "Displays guests associated with this screening.",
  category: "Film",
  conditions: {
    multiple: false,
    postTypes: ["film"],
  },
}

export default defineBlock("film/film-guests", (props) => {
  const guests = props.film?.eventInfo?.guests
  if (!guests?.length) {
    if (env.admin) {
      return <AdminMessage>No guests have been attached to this event</AdminMessage>
    }
    return null
  }

  return (
    <div className="my-6">
      <EditableText store="title" defaultValue="Expected guests" as="h3" className="type-title-xs mb-2" />
      <EditableText
        as="p"
        className="type-body-xs !opacity-80 mt-3"
        store="description"
        placeholder="Enter some optional notes about guests here"
      />
      {guests.map((guest, i) => (
        <div key={i} className="flex justify-between gap-4 border-b border-b-grey8 pt-4 pb-3">
          <div className="type-body-l">{guest?.name}</div>
          <div className="type-body-l">{guest?.role}</div>
        </div>
      ))}
    </div>
  )
})
